// extracted by mini-css-extract-plugin
export default {"suffixInput":"style_suffixInput__AqCZL","suffixInputOnTableSpan":"style_suffixInputOnTableSpan__OJ9uK","suffixInputOnTable":"style_suffixInputOnTable__6gDyA"};